import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  TASK_APPROVAL_CACHE_KEY,
  TASK_CACHE_KEY,
  TASK_BY_ID_CACHE_KEY,
  TASKS_CACHE_KEY,
} from "@/src/lib/data-fetchers/tasks-fetchers";
import type { ResolveAthenaCoverage } from "@/src/models/athena-coverage-resolution";
import { getAthenaCoverageResolution, submitAthenaCoverageResolution } from "@/src/requests/athena-coverage-resolution";

export function useAthenaCoverageResolution(taskId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["athena-coverage-resolution", taskId],
    queryFn: () => getAthenaCoverageResolution(taskId),
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}

export function useResolveAthenaCoverage(taskId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: ResolveAthenaCoverage) => submitAthenaCoverageResolution(taskId, input),
    onSuccess: async () => {
      await Promise.all(
        [TASK_APPROVAL_CACHE_KEY, TASK_CACHE_KEY, TASK_BY_ID_CACHE_KEY, TASKS_CACHE_KEY].map((key) =>
          queryClient.invalidateQueries({ queryKey: [key] })
        )
      );
    },
  });
}
